import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_ELOQUA } from './constants';
import { verifyEloqua } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { readToken } from 'utils/readToken';

export function* saveEloquaCode({ payload }) {
  const token = readToken();
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/integration/eloqua',
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });
    triggerNotification({
      title: 'Eloqua integrated successfully!',
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifyEloqua.success());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyEloqua.error(errorMessage));
  }
}

export default function* eloquaVerify() {
  yield takeLatest(VERIFY_ELOQUA.START, saveEloquaCode);
}
